import {
  EditorState,
  convertFromRaw,
  convertToRaw,
  AtomicBlockUtils
} from "draft-js";

// 添加自定义组件
// editorState:编辑器的editorState
// type:自定义组件类型
// data:组件内容
export default (editorState, type, data) => {
  // 获取编辑器ContentState对象
  const contentState = editorState.getCurrentContent();
  // 创建编辑器内容实体
  const contentStateWithEntity = contentState.createEntity(type, "IMMUTABLE", {
    data
  });
  // 创建新实体的键值
  const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
  // 把创建的实体添加到editorState中并返回新的editroState 对象
  let newEditorState = EditorState.set(editorState, {
    currentContent: contentStateWithEntity
  });

  // 给editorState 添加Block并返回添加后的对象
  // 添加一个自定义组件会添加三个block,
  // 分别为 prevEmptyBlock,contentBlock,nextEmptyBlock
  newEditorState = AtomicBlockUtils.insertAtomicBlock(
    newEditorState,
    entityKey,
    " "
  );

  // 转换新的editorState为 数据对象
  const newRawdata = convertToRaw(newEditorState.getCurrentContent());

  const len = newRawdata.blocks.length,
    // prevEmptyBlock 索引
    prevEmptyBlockIndex = len - 3,
    // prevEmptyBlock对象
    prevEmptyBlock = newRawdata.blocks[prevEmptyBlockIndex];
  // 判断prevEmptyBlock是否为unstyled对象并且内容为空
  // 如果是则在原对象上删除该block
  // 因为该空block会影响视觉上的效果，所以需要删除
  if (prevEmptyBlock.type == "unstyled" && prevEmptyBlock.text == "") {
    newRawdata.blocks.splice(prevEmptyBlockIndex, 1);
  }

  const newContetnState = convertFromRaw(newRawdata);
  newEditorState = EditorState.createWithContent(newContetnState);
  //  由于转换editorState对象，会失去编辑器焦点影响收入，所以需要移动编辑器关闭到末尾
  newEditorState = EditorState.moveFocusToEnd(newEditorState);
  return newEditorState;
};
